<template>
  <div>
    <app-spinner v-if="!receiptQr" />
    <img class="app-receipt-qr__img" v-if="receiptQr" :src="receiptQr" alt="receipt-qr" />
  </div>
</template>

<script>
import AppSpinner from '@ui/app-spinner/appSpinner.vue'


export default {
  name: 'appReceiptQr',
  components: { AppSpinner },
  props: {
    id: {
      type: Number,
      default: null,
    },
    idType: {
      type: String,
      default: 'id',
    },
  },
  data() {
    return {
      receiptQr: '',
      pollInterval: null
    }
  },
  methods: {
    async fetchReceiptQr() {
      if (!this.id) {
        return
      }

      try {
        const url = Routing.generate('receipt_qr', {
          idType: this.idType,
          id: this.id,
        })
        const response = await fetch(url)

        if (response.ok) {
          const res = await response.json()
          if (res.receiptQr) {
            this.receiptQr = res.receiptQr
          }
          clearInterval(this.pollInterval)
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
  mounted() {
    this.pollInterval = setInterval(this.fetchReceiptQr, 5000)
    this.fetchReceiptQr()
  },
  beforeUnmount() {
    clearInterval(this.pollInterval)
  },
}
</script>

<style>
.app-receipt-qr__img {
  max-width: 200px;
  max-height: 200px;
}
</style>
